import { Component, OnInit, OnDestroy } from '@angular/core';
import { StartFunctionResponseModel } from '../../../model/startFunctionResponseModel';
import { WorkflowModel } from '../../../model/workflowModel';
import { StorageService } from '../../../shared/security/StorageService';
import { SpinnerService } from '../../../shared/spinner/spinner.service';
import { Router } from '@angular/router';
import { StartFunctionService } from '../../../shared/utils/start-function.service';
import { EntityRenewalService } from '../entity-renewal.service';
import { CurrentPageWatcherService } from '../../../shared/utils/CurrentPageWatcher';
import { OfficeSelectableListModel } from '../../../model/officeSelectableListModel';
import * as $ from 'jquery';

@Component({
  selector: 'app-start-entity-renewal',
  templateUrl: './start-entity-renewal.component.html',
  styleUrls: ['./start-entity-renewal.component.css']
})
export class StartEntityRenewalComponent implements OnInit, OnDestroy {

  startFunction: StartFunctionResponseModel = {};
  workflow: WorkflowModel;

  title :string ="Renew Entity License";
  officeList : Array<OfficeSelectableListModel>=[];

  constructor(private startFunctionService: StartFunctionService,private entityRenewalService:EntityRenewalService,private currentPageWatcher: CurrentPageWatcherService,
    private storage: StorageService,private router:Router,
    private spinner: SpinnerService) { 
    this.startFunction = this.storage.getStartFunctionData();
    if(this.startFunction!=null && this.startFunction!=undefined && this.startFunction.Workflow!=null){
    this.workflow = this.startFunction.Workflow;
    this.title= this.workflow.WorkflowDisplayName;
  }
}

  ngOnInit() {
    this.title = this.workflow.WorkflowDisplayName;
    this.currentPageWatcher.pageChanged().emit(this.title);
  } 

  startWorkFlow(){

    // this.entityRenewalService.getInactiveOffices(this.workflow.WorkflowID).subscribe(
    //   (resp: OfficeSelectableListModel[]) => {
    //     console.log("selectableList ", resp);
    //     resp.forEach(element => {
    //       this.officeList.push(element);
    //       this.spinner.hide();
    //     });
    let currentStep = this.workflow.CurrentStepIndex;
        if(this.workflow.Steps[currentStep + 1].WorkflowStepType == 48){
          this.router.navigate(["/entityRenewalQuestionnaire"]).then(()=>{
            this.startFunctionService.getNotifyStepInProgress().emit(true);
           // this.startFunctionService.getNotifyStepInProgress().emit(true);
            this.entityRenewalService.getNotifySelectInactiveOfficesToRenewResponseModel().emit(null);
          })
        }

        else{
          this.router.navigate(['/inactiveOfficesToRenew']).then(() => {
            this.startFunctionService.getNotifyStepInProgress().emit(true);
          });
        }
      
     
      // })
   
  }

  goBackHome(){
    this.router.navigate(['/home']);
  }

  ngOnDestroy(): void {
    this.currentPageWatcher.clearUserMessage();
    this.currentPageWatcher.clearStepMessage();
  }

}



// WEBPACK FOOTER //
// ./src/app/renewal/entity-renewal/start-entity-renewal/start-entity-renewal.component.ts